module.exports = __webpack_public_path__ + "static/media/incident_category-health.c2df1935.svg";